/* eslint-disable */
import $ from "jquery";
import { chain, forEach, memoize, some } from "lodash";
import { commonClientResx } from "../../resxDist/commonClientResx";
import { inlineEditResx } from "../../resxDist/inlineEditResx";
import "../EpEnums";
import { days } from "../EpEnums";
import { lingvoUtility } from "../LingvoUtility";
import { numericUtility } from "../NumericUtility";
import { currentCultureSettings } from "../setCulture";
import { timeUtility } from "./TimeUtility";
import {commonResx} from "../../resxDist/commonResx";
import { calculateStartLag, calculateStartDate, calculateEndDate, calculateEndLag } from "./FractionalDateHelper";
import { epFormat } from "../../utils/epFormat";
import { defaultMinDate, defaultMaxDate } from "./consts";

ep.common = ep.common || {};

var internalDateFormat = "dd.mm.yy";

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

ep.common.daysNamesByNumber = [
    days.sunday,
    days.monday,
    days.tuesday,
    days.wednesday,
    days.thursday,
    days.friday,
    days.saturday
];
export const daysNamesByNumber = ep.common.daysNamesByNumber;

var defaultDayOfWeeks = memoize(function () {
    var obj = {};
    forEach(daysNamesByNumber, function (name, index) {
        obj[name] = index;
    });

    return obj;
});

const EmptyPublicHolidays = [];

export const dateUtility = { 
    _initialized: false,
    ellipses: "\u2026", // code \u2026 it's ellipses
    separator: " - ",

    _initialize: function() {
        if (this._initialized)
            return;

        this._initialized = true;
    },

    isCurrentYear: function(date) {
        var current_date = this._getCurrentDate();
        var current_year = current_date.getFullYear();
        var source_year = date.getFullYear();
        return current_year === source_year;
    },

    formatAsMediumOrShort: function(date, alwaysShowYear = false) {
        if (!date) {
            return "";
        }

        return this.isCurrentYear(date) && !alwaysShowYear ? this.formatAsShort(date) : this.formatAsMediumFullYear(date);
    },

    formatAsFullOrShort: function (date) {
        if (!date) {
            return "";
        }
        var _this = this;
        return _this.isCurrentYear(date) ? _this.formatAsShort(date) : _this.formatAsFull(date);
    },

    firstDay: function () {
        return currentCultureSettings.firstDay;
    },

    formatWithDefault: function(format, date, defaultValue) {
        if (date) {
            return $.datepicker.formatDate(format, date);
        }
        return defaultValue;
    },

    format: function(format, date) {
        return $.datepicker.formatDate(format, date);
    },

    formatAsFull: function(date) {
        return $.datepicker.formatDate(currentCultureSettings.FullFormat, date);
    },

    formatAsFullWithTime : function(date, options) {
        if (!date) {
            return "";
        }
        options = options || {};
        if (options.isUtc) {
            date = timeUtility.toUserTime(date);
        }
       return this.formatAsFull(date) + ", " + timeUtility.formatAsShortTime(date);
    },

    formatAsMedium: function(date) {
        return $.datepicker.formatDate(currentCultureSettings.mediumFormat, date);
    },

    formatAsMediumFullYear: function(date) {
        return $.datepicker.formatDate(currentCultureSettings.mediumFullYearFormat, date);
    },

    formatAsDateFormat: function(date) {
        return $.datepicker.formatDate(currentCultureSettings.dateFormat, date);
    },

    formatAsShort: function(date, nullText) {
        if (date) {
            return $.datepicker.formatDate(currentCultureSettings.shortFormat, date);
        }
        return nullText || "";
    },

    formatAsMonthShortFormat: function(date) {
        return $.datepicker.formatDate(currentCultureSettings.monthShortFormat, date);
    },

    formatAsYear: function(date) {
        if (date) {
            return $.datepicker.formatDate(currentCultureSettings.yearFormat, date);
        }

        return nullText || "";
    },

    formatAsDayName: function(date, nullText) {
        if (date) {
            return currentCultureSettings.dayNames[date.getDay()];
        }
        return nullText || "";
    },

    formatAsShortMin: function(date, nullText) {
        if (date) {
            return currentCultureSettings.dayNamesMin[date.getDay()];
        }
        return nullText || "";
    },

    formatAsDayNameFirstLetter: function(date, nullText) {
        if (date) {
            return this.formatAsShortMin(date).charAt(0);
        }
        return nullText || "";
    },


    getDayMinName: function (dayIndex) {
        return currentCultureSettings.dayNamesMin[dayIndex];
    },

    parseDateFromInternalFormat: function(dateString) {
        return $.datepicker.parseDate(internalDateFormat, dateString || "");
    },

    isValidDateFromLocalFormat: function(dateString) {
        var date;
        try {
            date = $.datepicker.parseDate($.datepicker._defaults.dateFormat, dateString);
        } catch (e) {
            return false;
        }

        if (date !== null && !this.isValidMaxMinDate(date)) {
            return false;
        }

        return true;
    },

    isValidMaxMinDate: function(date) {
        return date.getTime() >= defaultMinDate.getTime() && date.getTime() <= defaultMaxDate.getTime();
    },

    parseDateFromLocalFormat: function(value) {
        var result;
        try {
            result = $.datepicker.parseDate($.datepicker._defaults.dateFormat, value || "");
        } catch (e) {
            result = null;
        }
        return result;

    },

    toInternalString: function(date) {
        return $.datepicker.formatDate(internalDateFormat, date);
    },

    getNextDay: function(date, count) {
        if (typeof count != 'number') count = 1;
        return this.addDays(date, count);
    },

    getPreviousDay: function(date, count) {
        if (typeof count != 'number') count = 1;
        return this.addDays(date, -count);
    },

    getNextDateMonth: function(date, count) {
        return this.addMonths(this.getFirstDateMonth(date), count);
    },

    getPreviousDateMonth: function(date, count) {
        count = count || 1;
        return this.addMonths(this.getFirstDateMonth(date), -count);
    },

    getPreviousDateYear: function(date, count) {
        if (typeof count != 'number') count = 1;
        var copiedDate = this.copy(date);
        copiedDate.setFullYear(copiedDate.getFullYear() - count);
        return copiedDate;
    },

    getNextDateYear: function(date, count) {
        if (typeof count != 'number') count = 1;
        var copiedDate = this.copy(date);
        copiedDate.setFullYear(copiedDate.getFullYear() + count);
        return copiedDate;
    },

    isCompareWithCurrentYear: function(date) {
        var currentYear = this._getCurrentDate().getFullYear();
        var compareYear = date.getFullYear();
        return (compareYear === currentYear);
    },
    
    _getCurrentDate: function(){
        return new Date();
    },

    isCompareWithCurrentYears: function(dateFirst, dateSecond) {
        return this.isCompareWithCurrentYear(dateFirst) && this.isCompareWithCurrentYear(dateSecond);
    },
    
    today: function() {
        let today = this._getCurrentDate();
        this.toDayStart(today);

        return today;
    },

    isToday: function(date) {
        const today = this.today();
        const dateStart = this.toDayStart(date);

        return this.strictEqual(today, dateStart);
    },

    getShortWeekTitles: function(){
        let result = [];
        let firstDay = this.firstDay();
        for (let i = 0; i < 7; i++) {
            const dayIndex = (firstDay + i) % 7;
            result.push({
                dayIndex: dayIndex,
                title: currentCultureSettings.dayNamesMin[dayIndex]
            });
        }
        return result;
    },
        
    /*get week dates by the date of the day in this week*/
    getWeekDates: function (date) {
        let weekDates = [];

            let localWeekStart = this.getWeekStart(date);

            for(let i = 0; i < 7; i++){
                weekDates.push(this.addDays(localWeekStart, i));
        }

        return weekDates;
    },
    
    toDayStart: function(date, isUTC) {
        if (isUTC) {
            date.setUTCMilliseconds(0);
            date.setUTCSeconds(0);
            date.setUTCMinutes(0);
            date.setUTCHours(0);
        } else {
            date.setMilliseconds(0);
            date.setSeconds(0);
            date.setMinutes(0);
            date.setHours(0);
        }
        return date;
    },

    toDayEnd: function(date, isUTC) {
        if (!date) {
            return date;
        }

        return this.addSeconds(this.addDays(this.toDayStart(date, isUTC), 1), -1);
    },

    getDayOfWeek: function(date) {
        return (7 + date.getDay() - currentCultureSettings.firstDay) % 7;
    },

    getNextMonth: function(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    },

    getPrevMonth: function(date) {
        return new Date(date.getFullYear(), date.getMonth() - 1, 1);
    },

    getFullMonthsBetween: function(dateFrom, dateTo) {
        var months;
        months = (dateTo.getFullYear() - dateFrom.getFullYear()) * 12;
        months -= dateFrom.getMonth() + 1;
        months += dateTo.getMonth();
        return months;
    },

    formatAsMonthDay: function(date) {
        return $.datepicker.formatDate(currentCultureSettings.monthDayFormat, date);
    },

    daysInMonthOf: function(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    },

    getMonthName: function(date) {
        return this.getMonthNameByNumber(date.getMonth());
    },

    getMonthNameShort: function(date) {
        return currentCultureSettings.monthNamesShort[date.getMonth()];
    },

    getMonthNameByNumber: function(num) {
        return currentCultureSettings.monthNames[num];
    },

    getMonthNameWithYear: function(date) {
        return this.getMonthName(date) + " " + date.getFullYear();
    },

    getMonthNameShortWithYear: function(date) {
        return this.getMonthNameShort(date) + ", " + date.getFullYear();
    },

    getMonthNameWithOrWithoutYear: function (date) {
        if (!date) {
            return "";
        }
        var _this = this;
        return _this.isCurrentYear(date) ? _this.getMonthName(date) : _this.getMonthNameWithYear(date);
    },

    getMonthNameShortWithOrWithoutYear: function(date) {
        if (!date) {
            return "";
        }

        return this.isCurrentYear(date) ? this.getMonthNameShort(date) :
            this.getMonthNameShortWithYear(date);
    },

    compareDates: function(firstDate, secondDate) {
        if (!firstDate && !secondDate) {
            return 0;
        }

        if (!firstDate) {
            return -1;
        }

        if (!secondDate) {
            return 1;
        }

        if (firstDate.getFullYear() !== secondDate.getFullYear()) {
            return firstDate.getFullYear() > secondDate.getFullYear();
        }

        if (firstDate.getMonth() !== secondDate.getMonth()) {
            return firstDate.getMonth() > secondDate.getMonth();
        }

        if (firstDate.getDate() !== secondDate.getDate()) {
            return firstDate.getDate() > secondDate.getDate();
        }

        return 0;
    },

    compareMonths: function(firstDate, secondDate) {
        if (!firstDate && !secondDate) {
            return true;
        }

        if (!firstDate || !secondDate) {
            return false;
        }

        if (firstDate.getFullYear() !== secondDate.getFullYear()) {
            return false;
        }

        return firstDate.getMonth() === secondDate.getMonth();
    },

    compareYears: function(firstDate, secondDate) {
        if (!firstDate && !secondDate) {
            return true;
        }

        if (!firstDate || !secondDate) {
            return false;
        }

        return firstDate.getFullYear() === secondDate.getFullYear();
    },

    compareQuarters: function(firstDate, secondDate){
        if (!firstDate && !secondDate) {
            return true;
        }

        if (!firstDate || !secondDate) {
            return false;
        }

        return this.compareYears(firstDate, secondDate) &&
            this.getQuarter(firstDate) === this.getQuarter(secondDate);
    },

    daysDiff: function(first, second) {
        var firstDate = Date.UTC(first.getFullYear(), first.getMonth(), first.getDate());
        var secondDate = Date.UTC(second.getFullYear(), second.getMonth(), second.getDate());

        return Math.ceil((secondDate - firstDate) / _MS_PER_DAY);
    },

    addDays: function(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    },

    addSeconds: function(date, number) {
        var result = new Date(date)
        result.setSeconds(date.getSeconds() + number)
        return result;
    },

    addYears: function(date, count) {
        return this.getPreviousDateYear(date, -count);
    },

    addMonths: function(date, count) {
        if (typeof count != 'number') count = 1;
        let copiedDate = this.copy(date);
        copiedDate.setMonth(copiedDate.getMonth() + count);
        return copiedDate;
    },

    addQuarters: function(date, count){
        const result = new Date(date);
        result.setMonth(result.getMonth() + 3 * count);
        return result;
    },

    copy: function(date) {
        if (!date)
            return null;

        var result = this._getCurrentDate();
        result.setTime(date.getTime());
        return result;
    },

    isWeekEnd: function(date) {
        var day = date.getDay();
        return (day == 6) || (day == 0);
    },

    isNextDay: function(date, nextDate) {
        return dateUtility.strictEqual(dateUtility.addDays(date, 1), nextDate);
    },

    isNotWorkingDay: function(date, scheduleSettings) {
        const treatWeekendAsWorkdays = scheduleSettings && scheduleSettings.TreatWeekendAsWorkdays;

        if (this.isWeekEnd(date) && !treatWeekendAsWorkdays) {
            return true;
        }

        return false;
    },

    isPublicHoliday: function(date, scheduleSettings) {
        return some(scheduleSettings.PublicHolidays, holiday =>
            this.compareDates(date, holiday.Date) === 0
        );
    },

    isWorkingDay: function(date, scheduleSettings) {
        if (this.isNotWorkingDay(date, scheduleSettings)) {
            return false;
        } else {
            if (this.isPublicHoliday(date, scheduleSettings)) {
                return false;
            }
            if (scheduleSettings.DisabledDates){
                for (let i = 0; i < scheduleSettings.DisabledDates.length; i++) {
                    const disabledDate = scheduleSettings.DisabledDates[i];
                    if (this.isDateBetween(disabledDate.from, disabledDate.to, date)) {
                        return false;
                    }
                }
            }
        }

        return true;
    },

    getRealDuration: function(start, duration, durationHours, lag, scheduleSettings, lookForward) {
        var increment = lookForward ? 1 : -1;
        var result = 0;

        var startDate = new Date(start);
        var endDate = lookForward
            ? calculateEndDate(start, lag, duration, durationHours)
            : calculateStartDate(start, lag, duration, durationHours);

        for (var d = startDate; lookForward ? d <= endDate : d >= endDate; d.setDate(d.getDate() + increment)) {
            if (!this.isWorkingDay(d, scheduleSettings)) {
                result++;
                endDate.setDate(endDate.getDate() + increment);
            }
        }

        return result + duration;
    },
    /*end we do not include in range*/
    workingDaysDiff: function(start, end, scheduleSettings) {
        var result = 0;

        var startDate = new Date(start);
        var endDate = new Date(end);

        var invertResult = false;

        if (startDate > endDate) {
            var tmp = endDate;
            endDate = startDate;
            startDate = tmp;

            invertResult = true;
        }

        for (var d = startDate; d < endDate; d.setDate(d.getDate() + 1)) {
            if (this.isWorkingDay(d, scheduleSettings)) {
                result++;
            }
        }

        return invertResult ? -result : result;
    },

    extendDurationFromStart: function(startDate, duration, durationHours, startLag, scheduleSettings) {
        return this.getRealDuration(startDate, duration, durationHours, startLag, scheduleSettings, true);
    },

    extendDurationFromEnd: function(endDate, duration, durationHours, endLag, scheduleSettings) {
        return this.getRealDuration(endDate, duration, durationHours, endLag, scheduleSettings, false);
    },

    closestWorkingDay: function(scheduleSettings, getDate, lookBackward) {
        var currDate = this._getCurrentDate();
        if (getDate) {
            currDate = (getDate instanceof Date) ? new Date(getDate) : new Date(getDate());
        }

        var findWorkingDay = function(date) {
            if (this.isWorkingDay(date, scheduleSettings))
                return date;

            date.setDate(date.getDate() + (lookBackward ? -1 : 1));
            return findWorkingDay.call(this, date);
        };

        return findWorkingDay.call(this, currDate);
    },

    getWorkingDuration: function (start, end, startLag, endLag, scheduleSettings) {
        if (start == null || end == null) {
            return null;
        }

        var hoursPerDay = ep.options.general.HoursPerDay;

        var additionalDay = this.isWorkingDay(start > end ? start : end, scheduleSettings) ? 1 : 0;
        var days = this.workingDaysDiff(start, end, scheduleSettings) + additionalDay;


        var startHours = 0;
        var endHours = 0;

        if (startLag > 0)
        {
            startHours = hoursPerDay - startLag;
        }

        if (endLag > 0)
        {
            endHours = endLag;
        }

        var invertedSum = startLag + (hoursPerDay - (endLag === 0 ? hoursPerDay : endLag));

        var hours = (startHours + endHours) % hoursPerDay;

        days = days - Math.floor(invertedSum / hoursPerDay) - (hours > 0 ? 1 : 0);

        return {Days: days, Hours: hours};
    },

    correctDatesForDuration: function(startDate, endDate, duration, durationHours, lag, scheduleSettings) {
        var startLag = 0, endLag = 0, extendedDuration = 0;

        lag = lag || 0;

        if (startDate || !endDate) {
            if (!startDate) {
                startDate = this.closestWorkingDay(scheduleSettings, scheduleSettings.getToday);
            }

            extendedDuration = this.extendDurationFromStart(startDate, duration, durationHours, lag, scheduleSettings);
            endDate = calculateEndDate(startDate, lag, extendedDuration, durationHours);
            startLag = lag;
            endLag = calculateEndLag(lag, durationHours);
        } else {
            extendedDuration = this.extendDurationFromEnd(endDate, duration, durationHours, lag, scheduleSettings);
            startDate = calculateStartDate(endDate, lag, extendedDuration, durationHours);
            endLag = lag;
            startLag = calculateStartLag(lag, durationHours);
        }
        return {
            startDate: startDate,
            endDate: endDate,
            duration: extendedDuration,
            durationHours: durationHours,
            startLag: startLag,
            endLag: endLag
        };
    },

    isDateBetween: function(start, end, current) {
        return this.daysDiff(start, current) >= 0 && this.daysDiff(current, end) >= 0;
    },

    isIntersecting: function(start1, end1, start2, end2) {
        return this.isDateBetween(start1, end1, start2) || this.isDateBetween(start1, end1, end2) ||
            this.isDateBetween(start2, end2, start1) || this.isDateBetween(start2, end2, end1);
    },

    intersect: function(start1, end1, start2, end2) {
        if (!this.isIntersecting(start1, end1, start2, end2)) {
            return null;
        }

        const start = start1 > start2 ? start1 : start2;
        const end = end1 < end2 ? end1 : end2;

        return {
            from: start,
            to: end
        };
    },

    formatDurationFullNames: function(days, hours) {
        var dayPart = '';
        var hourPart = '';

        if (days > 0) {
            dayPart = lingvoUtility.plural(days, commonClientResx.DayPluralFormatTemplate);
        }

        if (hours > 0) {
            hourPart = lingvoUtility.plural(hours, commonClientResx.HourPluralFormatTemplate);
        }

        if (days > 0) {
            return epFormat('{0} {1}', dayPart, hourPart).trim();
        }

        return hourPart.trim();
    },

    formatDuration: function(days, hours, forceDayAbbr) {
        if (days == undefined && hours == undefined) {
            return '';
        }

        var formated = '';

        if (days >= 0) {
            if (hours > 0 || forceDayAbbr) {
                formated = epFormat('{0}{1}', days, commonClientResx.DayAbbreviation);
            } else {
                formated = epFormat('{0}', days);
            }
        }

        if (hours > 0) {
            var hoursStr = numericUtility.formatLocal(hours);
            if (days > 0) {
                formated = epFormat('{0} {1}{2}', formated, hoursStr, commonClientResx.HourAbbreviation);
            } else {
                formated = epFormat('{0}{1}', hoursStr, commonClientResx.HourAbbreviation);
            }
        }

        return formated.trim();
    },

    formatHours: function(hours) {
        var hoursStr = numericUtility.formatLocal(hours);
        return hoursStr && `${hoursStr}${commonClientResx.HourAbbreviation}`;
    },

    getElapsedTimeRepresentation: function (date, options) {
        if (date == null) {
            return "";
        }

        options = options || {};
        if (options.isUtc) {
            date = timeUtility.toUserTime(date);
        }
        const now = options.now || this._getCurrentDate().getTime();
        const nowDate = new Date(now);
        const resx = commonClientResx;
        
        const diffInMin = Math.floor((now - date.valueOf()) / (1000 * 60));
        const diffInHours = Math.floor(diffInMin / 60);

        let isToday = diffInHours >= 1 && diffInHours < 24 && date.getDay() === nowDate.getDay();
        let isYesterday = diffInHours >= 1 && diffInHours < 48 && this.addDays(nowDate, -1).getDay() === date.getDay()

        let time = options.includeTime ? ", " + timeUtility.formatAsShortTime(date) : "";
        
        if (diffInHours == 0) {
            return epFormat(resx.ElapsedTime_Ago, lingvoUtility.plural(diffInMin || 1, resx.MinutePluralFormat));
        } else if (isToday) {
            return epFormat(resx.ElapsedTime_Ago, lingvoUtility.plural(diffInHours || 1, resx.HourPluralFormatTemplate));
        } else if (isYesterday) {
            return commonResx.yesterday + time;
        }
        else if (nowDate.getFullYear() === date.getFullYear()) {
            return this.formatAsShort(date) + time;
        } else {
            return this.formatAsFull(date);
        }
    },

    getEPStandardDateTimeFormat: function(date, options = {}) {
        if (date == null) {
            return "";
        }

        options = {
            includeTime: true,
            ...options,
        };
        if (options.isUtc) {
            date = timeUtility.toUserTime(date);
        }

        const time = options.includeTime ? ", " + timeUtility.formatAsShortTime(date) : "";

        return this.formatAsMediumOrShort(date) + time;
    },

    getInvalidDateFormatMsg: function() {
        return inlineEditResx.Validation_InvalidDate.replace('{0}', currentCultureSettings.datePlaceholder);
    },
    
    orderedDays: function () {
        var daysNames = chain(ep.days)
            .values()
            .map(function(x) {
                return {
                    name: x,
                    dayOfWeek: ep.common.dateUtility.getDayOfWeekIndex(x)
                };
            })
            .sortBy(function(x) {
                return x.dayOfWeek;
            })
            .map(function(x) {
                return x.name;
            })
            .value();

        return daysNames;
    },

    getDayOfWeekIndex: function (name) {
        var firstDayOfWeek = ep.common.daysNamesByNumber[ep.common.dateUtility.firstDay()];

        var defaultOrder = defaultDayOfWeeks();
        var offset = 7 - defaultOrder[firstDayOfWeek];

        var defaultDay = defaultOrder[name];

        return (defaultDay + offset) % 7;
    },

    getDelay: function (endDate) {
        if (!endDate)
            return null;

        return this.daysDiff(endDate, this.today());
    },

    formatMonthDatesRange: function(start, end) {
        if (!start && !end) {
            return "";
        }

        if (start && end) {
            let result;
            const isCompareYear = this.compareYears(start, end);
            const isCompareMonth = this.compareMonths(start, end);

            if (isCompareYear) {
                result = isCompareMonth ?
                    this.getMonthNameShortWithOrWithoutYear(start) :
                    this.getMonthNameShort(start) + this.separator + this.getMonthNameShortWithOrWithoutYear(end);
            } else {
                result = this.getMonthNameShortWithYear(start) + this.separator + this.getMonthNameShortWithYear(end);
            }

            return result;
        }

        if (start) {
            return this.getMonthNameShortWithOrWithoutYear(start) + this.separator + this.ellipses;
        }

        return this.ellipses + this.separator + this.getMonthNameShortWithOrWithoutYear(end);
    },

    formatDatesRange: function(start, end, options = {}) {
        const { ignoreEmptyDates, alwaysShowYear } = { ignoreEmptyDates: false, alwaysShowYear: false, ...options };

        if (!start && !end && !ignoreEmptyDates) {
            return "";
        }

        if (!start && !end && ignoreEmptyDates) {
            return this.ellipses + this.separator + this.ellipses;
        }

        if (this.strictEqual(start, end)) {
            return this.formatAsMediumOrShort(start, alwaysShowYear);
        }

        if (start && end) {
            let result;
            const isCompareYear = this.compareYears(start, end);

            if (isCompareYear) {
                result = this.formatAsShort(start) + this.separator + this.formatAsMediumOrShort(end, alwaysShowYear);
            } else {
                result = this.formatAsMediumFullYear(start) + this.separator + this.formatAsMediumFullYear(end);
            }

            return result;
        }

        if (start) {
            return this.formatAsMediumOrShort(start, alwaysShowYear) + this.separator + this.ellipses;
        }

        return this.ellipses + this.separator + this.formatAsMediumOrShort(end, alwaysShowYear);
    },


    /**
    * Determine the week of the year based on the ISO 8601 definition.
    *
    * @param {Date} date - the date to get the week for
    * @return {Number} - the number of the week within the year that contains this date
    */

    getWeekNumber: function(date) {
        const checkDate = this.getWeekThursday(date);

        // Find Thursday of this week starting on Monday
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));

        const time = checkDate.getTime();
        checkDate.setMonth(0); // Compare with Jan 1
        checkDate.setDate(1);

        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
    },

    _formatAsShortWithYear: function(date){
        return this.formatAsShort(date) + ", " + date.getFullYear();
    },

    strictCompareDates: function (firstDate, secondDate) {
        if (!firstDate && !secondDate) {
            return 0;
        }

        if (!firstDate) {
            return -1;
        }

        if (!secondDate) {
            return 1;
        }

        return firstDate.getTime() - secondDate.getTime();
    },

    equal: function(firstDate, secondDate) {
        return this.compareDates(firstDate, secondDate) === 0;
    },

    strictEqual: function(firstDate, secondDate) {
        return this.strictCompareDates(firstDate, secondDate) === 0;
    },

    strictGreater: function (firstDate, secondDate) {
        return this.strictCompareDates(firstDate, secondDate) > 0;
    },

    strictGreaterOrEqual: function (firstDate, secondDate) {
        return this.strictCompareDates(firstDate, secondDate) >= 0;
    },

    strictLess: function (firstDate, secondDate) {
        return this.strictCompareDates(firstDate, secondDate) < 0;
    },

    strictLessOrEqual: function (firstDate, secondDate) {
        return this.strictCompareDates(firstDate, secondDate) <= 0;
    },

    getFirstDateMonth: function(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    },

    getLastDateMonth: function(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    },

    getFirstDateYear: function(date) {
        return new Date(date.getFullYear(), 0, 1);
    },

    getLastDateYear: function(date) {
        return new Date(date.getFullYear() + 1, 0, 0);
    },

    getWeekStart: function(date, fistDayOfWeek = this.firstDay()) {
        const localDayOfWeek = (7 + date.getDay() - fistDayOfWeek) % 7;

        return this.toDayStart(this.addDays(date, - localDayOfWeek));
    },

    getWeekEnd: function(date, fistDayOfWeek = this.firstDay()) {
        return this.addDays(this.getWeekStart(date, fistDayOfWeek), 6);
    },

    getWeekThursday: function(date, fistDayOfWeek = this.firstDay()) {
        return this.addDays(this.getWeekStart(date), 4 - fistDayOfWeek);
    },

    getDaysFromTo: function(dateFrom, dateTo) {
        let daysArray = [];

        if (!dateFrom && !dateTo) {
            return daysArray;
        }

        let currentDate = dateFrom || dateTo;
        let lastDate = dateTo || dateFrom;

        while (currentDate <= lastDate) {
            daysArray.push(currentDate);
            currentDate = this.getNextDay(currentDate, 1);
        }

        return daysArray;
    },

    getPartialWeeksFromTo: function(dateFrom, dateTo, workWeekStartsOn) {
        let weeksArray = [];
        let currentDate = dateFrom;
        for (; ;) {
            if (currentDate > dateTo){
                break;
            }

            let weekEnd = this.getWeekEnd(currentDate, workWeekStartsOn)
            if (weekEnd >= dateTo) {
                weeksArray.push({ from: currentDate, to: dateTo });
                break
            } else {
                weeksArray.push({ from: currentDate, to: weekEnd });
                currentDate = this.addDays(weekEnd, 1);
            }
        }

        return weeksArray;
    },

    getPartialMonthFromTo: function(dateFrom, dateTo) {
        let monthsArray = [];
        let currentDate = dateFrom;

        do {
            let monthEnd = this.getLastDateMonth(currentDate);

            if (monthEnd >= dateTo) {
                monthsArray.push({ from: currentDate, to: dateTo });
                break;
            } else {
                monthsArray.push({ from: currentDate, to: monthEnd });
                currentDate = this.addDays(monthEnd, 1);
            }
        } while (currentDate <= dateTo)

        return monthsArray;
    },

    getWeeksFromTo: function(dateFrom, dateTo, workWeekStartsOn) {
        let weeksArray = [];
        let currentDate = this.getWeekStart(dateFrom, workWeekStartsOn);
        let endDate = this.getWeekEnd(dateTo, workWeekStartsOn);

        while (currentDate <= endDate) {
            weeksArray.push(this.getDatesFromToThisWeek(currentDate, workWeekStartsOn));
            currentDate = this.getNextDay(currentDate, 7);
        }
        return weeksArray;
    },

    getMonthsFromTo: function(dateFrom, dateTo) {
        let monthsArray = [];
        let currentDate = this.getFirstDateMonth(dateFrom);
        let endDate = this.getLastDateMonth(dateTo);

        while (currentDate <= endDate) {
            monthsArray.push(this.getDatesFromToThisMonth(currentDate));
            currentDate = this.getNextDateMonth(currentDate);
        }

        return monthsArray;
    },

    getDatesFromToThisWeek: function(date, workWeekStartsOn) {
        let weekStart = this.getWeekStart(date, workWeekStartsOn);

        return {
            from: this.addDays(weekStart, 0),
            to: this.addDays(weekStart, 6),
        };
    },

    getDatesFromToPreviousWeek: function(date, workWeekStartsOn) {
        const previousDate = this.getPreviousDay(date, 7);

        return this.getDatesFromToThisWeek(previousDate, workWeekStartsOn);
    },

    getDatesFromToNextWeek: function(date, workWeekStartsOn) {
        const nextDate = this.getNextDay(date, 7);

        return this.getDatesFromToThisWeek(nextDate, workWeekStartsOn);
    },

    getDatesFromToThisMonth: function(date) {
        return {
            from: this.getFirstDateMonth(date),
            to: this.getLastDateMonth(date),
        };
    },

    getDatesFromToPreviousMonth: function(date) {
        const previousMonth = this.getPreviousDateMonth(date);

        return this.getDatesFromToThisMonth(previousMonth);
    },

    getDatesFromToNextMonth: function(date) {
        const nextMonth = this.getNextDateMonth(date);

        return this.getDatesFromToThisMonth(nextMonth);
    },

    getDatesFromToThisQuarter: function(date) {
        return {
            from: this.getFirstDateQuarter(date),
            to: this.getLastDateQuarter(date),
        };
    },

    getDatesFromToPreviousQuarter: function(date) {
        const previousQuarter = this.getPreviousDateMonth(date, 3);

        return this.getDatesFromToThisQuarter(previousQuarter);
    },

    getDatesFromToNextQuarter: function(date) {
        const nextQuarter = this.getNextDateMonth(date, 3);

        return this.getDatesFromToThisQuarter(nextQuarter);
    },

    getDatesFromToThisYear: function(date) {
        return {
            from: this.getFirstDateYear(date),
            to: this.getLastDateYear(date),
        };
    },

    getDatesFromToPreviousYear: function(date) {
        const previousYear = this.getPreviousDateYear(date);

        return this.getDatesFromToThisYear(previousYear);
    },

    getDatesFromToNextYear: function(date) {
        const nextYear = this.getNextDateYear(date);

        return this.getDatesFromToThisYear(nextYear);
    },

    getQuarter: function (date) {
        return Math.floor(date.getMonth() / 3);
    },

    formatQuarter: function (date) {
        return commonResx[`short_quarter${this.getQuarter(date)}`];
    },

    formatQuarterWithOrWithoutYear: function (date) {
        const shownYear = !this.isCurrentYear(date) ? ` ${date.getFullYear()}` : "";

        return `${this.formatQuarter(date)}${shownYear}`
    },

    getFirstDateQuarter: function(date) {
        const quarterNumber = this.getQuarter(date);
        return new Date(date.getFullYear(), quarterNumber * 3, 1);
    },

    getLastDateQuarter: function (date) {
        const quarterNumber = this.getQuarter(date) + 1;
        return new Date(date.getFullYear(), quarterNumber * 3, 0);
    },

    isAvailableDate: function(date, scheduleSettings) {
        if (date && scheduleSettings.DisabledDates) {
            for (const dates of scheduleSettings.DisabledDates) {
                if (dateUtility.isDateBetween(dates.from, dates.to, date)) {
                    return false;
                }
            }
        }

        return true;
    },

    getMinMaxDates: function(...dates) {
        function compare2Date(date1, date2){
            switch (dateUtility.compareDates(date1, date2)) {
                case 1:
                    return { minDate: date1, maxDate: date1 };
                case -1:
                    return { minDate: date2, maxDate: date2 };
                case 0:
                    return { minDate: date1, maxDate: date1 };
                case true:
                    return { minDate: date2, maxDate: date1 };
                case false:
                    return { minDate: date1, maxDate: date2 };
                default:
                    return { minDate: undefined, maxDate: undefined };
            }
        }

        return dates.reduce((acc, date) => {
            let c1 = compare2Date(acc.minDate, date);
            let c2 = compare2Date(acc.maxDate, date);
            return {minDate: c1.minDate, maxDate: c2.maxDate};
        }, { minDate: undefined, maxDate: undefined });
    },

    mergeScheduleSettings(originSchedule, overrideSchedule) {
        if (overrideSchedule) {
            const { IgnorePublicHolidays, ...override } = overrideSchedule;
            return {
                ...originSchedule,
                ...override,
                PublicHolidays: IgnorePublicHolidays ? EmptyPublicHolidays : originSchedule.PublicHolidays,
            }
        }

        return originSchedule;
    }

};

ep.common.dateUtility = dateUtility;

/* eslint-enable */
